<template>
  <div>
    <template v-for="(payment, index) in value">
      <span :key="'s' + index">{{
        `${payment.date} | ${payment.hours} ч.${
          payment.package ? " | " + payment.package.title : ""
        }`
      }}</span>
      <br
        v-if="index < value.length - 1"
        :key="'b' + index"
      >
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
};
</script>